export const iconFontAwesomeMapsFlag = (
	<i className="fa-solid fa-flag"></i>
);
